// Carry API data from the react-snap prerender pass into the shipped HTML so
// pages hydrate straight into their final content.
//
// Without this, BlogPost/Blog started in a "loading" state on hydration: the
// prerendered article was swapped for a spinner, then re-rendered after a
// fresh API call — ~8 s of LCP render delay on mobile, plus a layout flash.
//
// How: during the prerender pass components call rememberForSnapshot(key,
// data). react-snap calls window.snapSaveState() just before saving the page
// and inlines the result as window.__PRERENDER_DATA__ = {...}. In the browser,
// readSnapshot(key) returns that data for the first render.

const KEY = "__PRERENDER_DATA__";
const isBrowser = typeof window !== "undefined";
const isPrerender =
    typeof navigator !== "undefined" && navigator.userAgent.includes("ReactSnap");

// React renders `{city} Exterior` as two adjacent text nodes. Serializing the
// DOM to HTML merges them into one, so on hydration React finds one text node
// where it expects two, throws error #418 and throws away the whole
// prerendered page to re-render it client-side (on every page). React's own
// SSR avoids this by emitting <!-- --> between adjacent text nodes, which the
// hydrator skips — do the same right before react-snap serializes the page.
const separateAdjacentTextNodes = (root) => {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const texts = [];
    let n;
    while ((n = walker.nextNode())) texts.push(n);
    texts.forEach((t) => {
        if (t.nextSibling && t.nextSibling.nodeType === Node.TEXT_NODE) {
            t.parentNode.insertBefore(document.createComment(" "), t.nextSibling);
        }
    });
};

if (isBrowser && isPrerender) {
    window.__SNAP_COLLECT__ = window.__SNAP_COLLECT__ || {};
    // react-snap calls this immediately before it serializes the page.
    window.snapSaveState = () => {
        separateAdjacentTextNodes(document.getElementById("root"));
        return { [KEY]: window.__SNAP_COLLECT__ };
    };
}

export const rememberForSnapshot = (key, data) => {
    if (isBrowser && isPrerender) window.__SNAP_COLLECT__[key] = data;
};

export const readSnapshot = (key) => {
    if (!isBrowser || isPrerender) return undefined;
    const store = window[KEY];
    return store && Object.prototype.hasOwnProperty.call(store, key) ? store[key] : undefined;
};
